import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'edex-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.scss']
})
export class TransactionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
